/* =========================================================
   ZEPTO STYLE ADD TO BAG - cart logic
   Powers <zepto-add-to-cart> in snippets/zepto-add-to-cart.liquid
   and shares its cart state with assets/zepto-options.js
   Corrected popup integration; original shared cart logic retained.
   ========================================================= */
(function () {
  'use strict';
  if (window.ZeptoATCLoaded) return;
  window.ZeptoATCLoaded = true;
  /* ---------- Config (set window.ZeptoATCConfig before this file loads) ---------- */
  var CONFIG = Object.assign(
    {
      openDrawerOnAdd: true,         // open side cart on the first add from a card
      openDrawerOnQtyChange: false,   // open side cart when + / - is used on a card
      openDrawerFromOptions: false,  // keep the drawer shut while the options sheet is open
      debounce: 320,
      drawerSelectors: [
        '#m-cart-drawer', 'm-cart-drawer', 'cart-drawer', '.m-cart-drawer', '[data-cart-drawer]'
      ],
      drawerToggleSelectors: [
        '[data-open-cart-drawer]', '[data-cart-drawer-toggle]', '.m-cart-drawer-toggle',
        '[data-action="open-cart-drawer"]', '.m-header__cart-icon', '#m-cart-icon-bubble'
      ],
      countSelectors: [
        '[data-cart-count]', '[data-cart-item-count]', '.m-cart-count', '.m-cart-icon-bubble__count'
      ]
    },
    window.ZeptoATCConfig || {}
  );
  window.ZeptoATCConfig = CONFIG;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  /* ---------- Shared cart state ---------- */
  var instances = new Set();
  var subscribers = new Set();
  var variantLines = new Map(); // variantId -> { key, quantity }
  var productLines = new Map(); // productId -> [ { key, variantId, quantity } ]
  var lastCart = null;
  var fetching = null;
  function readCart(cart) {
    lastCart = cart;
    variantLines = new Map();
    productLines = new Map();
    (cart.items || []).forEach(function (item) {
      var existing = variantLines.get(item.variant_id);
      if (existing) {
        existing.quantity += item.quantity;
      } else {
        variantLines.set(item.variant_id, { key: item.key, quantity: item.quantity });
      }
      var group = productLines.get(item.product_id) || [];
      group.push({ key: item.key, variantId: item.variant_id, quantity: item.quantity });
      productLines.set(item.product_id, group);
    });
    instances.forEach(function (el) { el.syncFromCart(); });
    subscribers.forEach(function (fn) { try { fn(cart); } catch (e) {} });
    updateCartCount();
  }
  function fetchCart() {
    if (fetching) return fetching;
    fetching = fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(handleCartResponse)
      .then(function (cart) { readCart(cart); return cart; })
      .catch(function () { return null; })
      .finally(function () { fetching = null; });
    return fetching;
  }
  function refreshCartFresh() {
    return fetching ? fetching.then(function () { return fetchCart(); }) : fetchCart();
  }
  function handleCartResponse(res) {
    return res.json().then(function (data) {
      if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
      return data;
    });
  }
  function addToCart(id, quantity) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
    }).then(handleCartResponse);
  }
  function changeLine(key, quantity) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(handleCartResponse);
  }
  function quantityOfVariant(id) {
    var line = variantLines.get(Number(id));
    return line ? line.quantity : 0;
  }
  function linesOfProduct(id) {
    return productLines.get(Number(id)) || [];
  }
  function quantityOfProduct(id) {
    return linesOfProduct(id).reduce(function (sum, l) { return sum + l.quantity; }, 0);
  }
  /* ---------- Theme bridge ---------- */
  function firstMatch(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }
  function updateCartCount() {
    if (!lastCart || !Number.isInteger(lastCart.item_count)) return;
    var count = lastCart.item_count;
    CONFIG.countSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (typeof el.setCount === 'function') {
          el.setCount(count);
        } else {
          el.textContent = el.matches('m-cart-count, .m-cart-count') && count >= 100 ? '99+' : String(count);
        }
        el.classList.toggle('is-empty', count === 0);
        if (el.matches('m-cart-count, .m-cart-count')) {
          el.classList.toggle('m:hidden', count === 0);
          el.hidden = count === 0;
          var link = el.closest('.m-cart-icon-bubble');
          if (link) link.setAttribute('aria-label', String(count));
        }
      });
    });
  }
  function openDrawer() {
    var cart = window.MinimogTheme && window.MinimogTheme.Cart;
    if (cart && typeof cart.openCartDrawer === 'function') {
      return Promise.resolve()
        .then(function () { if (typeof cart.refreshCart === 'function') return cart.refreshCart(); })
        .then(function () { if (typeof cart.renderNewCart === 'function') return cart.renderNewCart(); })
        .then(function () { return cart.openCartDrawer(); });
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true, detail: { cart: lastCart, source: 'zepto-atc', open: true }
    }));
    return Promise.resolve();
  }
  function notifyTheme(shouldOpen) {
    updateCartCount();
    if (shouldOpen) return openDrawer();
  }
  function afterAdd(context) {
    if (window.ZeptoAddons && window.ZeptoAfterAddMode === 'combined') {
      if (window.ZeptoOptions) window.ZeptoOptions.close();
      window.ZeptoAddons.combined(context || {});
      return Promise.resolve();
    }
    if (window.ZeptoAddons && window.ZeptoAfterAddMode !== 'addons') {
      if (window.ZeptoOptions) window.ZeptoOptions.close();
      window.ZeptoAddons.confirm(context || {});
      return Promise.resolve();
    }
    if (window.ZeptoAddons && window.ZeptoAddons.available()) {
      if (window.ZeptoOptions) window.ZeptoOptions.close();
      return window.ZeptoAddons.fly(context || {}).then(function () {
        window.ZeptoAddons.open(context || {});
      });
    }
    return openDrawer();
  }
  /* ---------- Stay in sync when something else changes the cart ---------- */
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var promise = nativeFetch.apply(this, args);
    try {
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        promise.then(function () { setTimeout(fetchCart, 80); }).catch(function () {});
      }
    } catch (e) {}
    return promise;
  };
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__zeptoUrl = url;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(this.__zeptoUrl || '')) {
      this.addEventListener('load', function () { setTimeout(fetchCart, 80); });
    }
    return nativeSend.apply(this, arguments);
  };
  /* ---------- Money formatting ---------- */
  function formatMoney(cents, format) {
    var fmt = format || window.ZeptoATCMoneyFormat ||
      (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    if (typeof cents === 'string') cents = cents.replace('.', '');
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number === null) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      var main = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return main + (parts[1] ? decimal + parts[1] : '');
    }
    var match = fmt.match(placeholder);
    var value;
    switch (match && match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }
  /* ---------- The card element ---------- */
  function stop(e) { e.preventDefault(); e.stopPropagation(); }
  class ZeptoAddToCart extends HTMLElement {
    connectedCallback() {
      if (this.__ready) {
        instances.add(this);
        this.syncFromCart();
        return;
      }
      this.__ready = true;
      this.mode = this.dataset.mode === 'options' ? 'options' : 'variant';
      this.variantId = Number(this.dataset.variantId) || 0;
      this.productId = Number(this.dataset.productId) || 0;
      this.handle = this.dataset.productHandle || '';
      this.productTitle = this.dataset.productTitle || '';
      this.productUrl = this.dataset.productUrl || '';
      this.max = Number(this.dataset.max) || 99;
      this.quantity = 0;
      this.pending = false;
      this.pendingOpen = false;
      this.lines = [];
      this.addBtn = this.querySelector('[data-zepto-add]');
      this.qtyBox = this.querySelector('[data-zepto-qty]');
      this.countEl = this.querySelector('[data-zepto-count]');
      this.minusBtn = this.querySelector('[data-zepto-minus]');
      this.plusBtn = this.querySelector('[data-zepto-plus]');
      var self = this;
      if (this.addBtn) {
        this.addBtn.addEventListener('click', function (e) {
          if (self.mode === 'options') {
            // Only take over when this button is set to our popup.
            // Otherwise let the theme's own quickview handle the click.
            if (self.addBtn.hasAttribute('data-zepto-options')) {
              stop(e);
              self.openOptions();
            }
            return;
          }
          stop(e);
          if (self.pending) return;
          self.pendingAddons = true;
          self.pendingOpen = false;
          self.setQuantity(1);
        });
      }
      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', function (e) {
          stop(e);
          // More than one pack of this product in the cart: let the customer choose
          if (self.mode === 'options' && self.lines.length !== 1) return self.openOptions();
          if (self.pending || self.quantity >= self.max) return;
          self.pendingOpen = self.pendingOpen || CONFIG.openDrawerOnQtyChange;
          self.setQuantity(self.quantity + 1);
        });
      }
      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', function (e) {
          stop(e);
          if (self.pending) return;
          if (self.mode === 'options' && self.lines.length !== 1) return self.openOptions();
          self.setQuantity(self.quantity - 1);
        });
      }
      instances.add(this);
      this.syncFromCart();
      ensureCartLoaded();
    }
    disconnectedCallback() {
      instances.delete(this);
      clearTimeout(this.timer);
    }
    openOptions() {
      var useZepto = this.addBtn && this.addBtn.hasAttribute('data-zepto-options');
      if (useZepto && window.ZeptoOptions && this.handle) {
        return window.ZeptoOptions.open(this.handle, this.productUrl, this.productTitle);
      }
      if (this.addBtn && !useZepto) {
        // theme quickview: replay the click on the original button
        return this.addBtn.click();
      }
      // A missing popup must not navigate away from the collection.
      if (this.addBtn) this.addBtn.title = 'Options are still loading. Please try again.';
      console.warn('[zepto-atc] Options popup is not ready. Check zepto-options.js.');
    }
    syncFromCart() {
      if (this.pending) return; // a click of ours is still being saved
      if (this.mode === 'options') {
        this.lines = linesOfProduct(this.productId);
        this.quantity = quantityOfProduct(this.productId);
      } else {
        this.quantity = quantityOfVariant(this.variantId);
      }
      this.render();
    }
    render() {
      this.classList.toggle('is-active', this.quantity > 0);
      if (this.qtyBox) this.qtyBox.hidden = this.quantity <= 0;
      if (this.countEl) this.countEl.textContent = this.quantity;
      if (this.plusBtn) {
        this.plusBtn.disabled = this.mode === 'variant' && this.quantity >= this.max;
      }
    }
    setQuantity(next) {
      next = Math.max(0, Math.min(this.max, next));
      this.quantity = next;
      this.pending = true;
      this.render(); // instant, the request follows after the debounce
      clearTimeout(this.timer);
      var self = this;
      this.timer = setTimeout(function () { self.commit(); }, CONFIG.debounce);
    }
    commit() {
      var self = this;
      var target = this.quantity;
      var shouldOpen = this.pendingOpen;
      var showAddons = this.pendingAddons && target > 0;
      this.pendingAddons = false;
      this.pendingOpen = false;
      var line = this.mode === 'options'
        ? (this.lines.length === 1 ? this.lines[0] : null)
        : variantLines.get(this.variantId);
      if (!line && this.mode === 'options') { this.pending = false; return; }
      this.classList.add('is-loading');
      this.classList.remove('is-error');
      var feedback = this.querySelector('[data-zepto-error]');
      if (feedback) feedback.textContent = '';
      var request;
      if (!line) {
        if (target <= 0) {
          this.pending = false;
          this.classList.remove('is-loading');
          return;
        }
        request = addToCart(this.variantId, target);
      } else {
        request = changeLine(line.key, target);
      }
      request
        .then(function () { return refreshCartFresh(); })
        .then(function (freshCart) {
          if (!freshCart) throw new Error('Unable to confirm your bag. Please refresh before trying again.');
          self.pending = false;
          self.syncFromCart();
          if (showAddons) return afterAdd({ productId: self.productId, title: self.productTitle, source: self });
          return notifyTheme(shouldOpen);
        })
        .catch(function (err) {
          self.pending = false;
          self.classList.add('is-error');
          if (self.addBtn) self.addBtn.title = err.message;
          var feedback = self.querySelector('[data-zepto-error]');
          if (!feedback) { feedback = document.createElement('p'); feedback.setAttribute('data-zepto-error', ''); feedback.setAttribute('role', 'alert'); self.appendChild(feedback); }
          feedback.textContent = err.message || 'Unable to add this product. Please try again.';
          console.warn('[zepto-atc]', err.message);
          fetchCart().then(function () { self.syncFromCart(); });
          setTimeout(function () { self.classList.remove('is-error'); }, 2500);
        })
        .finally(function () { self.classList.remove('is-loading'); });
    }
  }
  var cartLoaded = false;
  function ensureCartLoaded() {
    if (cartLoaded) return;
    cartLoaded = true;
    fetchCart();
  }
  if (!customElements.get('zepto-add-to-cart')) {
    customElements.define('zepto-add-to-cart', ZeptoAddToCart);
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      if (e.detail && e.detail.source === 'zepto-atc') return;
      fetchCart();
    });
  });
  document.addEventListener('DOMContentLoaded', ensureCartLoaded);
  window.addEventListener('pageshow', function (e) { if (e.persisted) fetchCart(); });
  window.ZeptoATC = {
    refresh: refreshCartFresh,
    afterAdd: afterAdd,
    openDrawer: openDrawer,
    notify: notifyTheme,
    add: addToCart,
    change: changeLine,
    money: formatMoney,
    config: CONFIG,
    quantityOf: quantityOfVariant,
    quantityOfProduct: quantityOfProduct,
    linesOfProduct: linesOfProduct,
    lineOf: function (variantId) { return variantLines.get(Number(variantId)) || null; },
    subscribe: function (fn) {
      subscribers.add(fn);
      return function () { subscribers.delete(fn); };
    }
  };
  console.info('[zepto-atc] JS loaded');
})();


